import { render } from "./ContactBox.vue?vue&type=template&id=0c1052f9&scoped=true"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=0c1052f9&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1052f9"]])

export default __exports__